export default __webpack_public_path__ + "static/media/speaker-2.d7dea3c2.png";